export const environment = {
  production: false,
  API_URL: 'https://jodacare-backend-staging.herokuapp.com/api/',
  API_VERSION: 'v3/',
  TOKEN: 'jodacare-admin-token',
};
